import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import Axios from 'axios'

const API_URL = process.env.API_URL || 'https://api.wearebasetwo.com/api/'

const base = Axios.create({
  baseURL: API_URL,
  headers: {
     'Content-Type': 'application/json',
  }
});

base.interceptors.request.use(
  (config) => {
    let token = localStorage.getItem('token');

    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    return config;
  }, 

  (error) => {
    return Promise.reject(error);
  }
);

const currentUser = {
  userId : "",
  accountGroup : ""
}

Vue.prototype.$http = base;
Vue.prototype.$currentUser = currentUser;

import './registerServiceWorker'



Vue.config.productionTip = false;
Vue.use(Argon);
new Vue({
  router,
  render: h => h(App),
  mounted() {
    if (localStorage.currentUser) {
      this.$currentUser = localStorage.currentUser;
    }
  },
  watch: {
    $currentUser(newCurrentUser) {
      localStorage.currentUser = newCurrentUser;
    }
  }
}).$mount("#app");
